import React from 'react';
import type { FC } from 'react';
import { compareDesc } from 'date-fns';
import CustomerNoteCard from './CustomerNoteCard';
import { CustomerNoteModel } from '@/models/customer';

interface Props {
  readonly notes?: CustomerNoteModel[];
}

const CustomerNotes : FC<Props> = ({ notes }) => {
  if (notes === undefined || notes.length === 0) {
    return null;
  } else {
    return (
      <>
        { notes
            .sort((noteA, noteB) => compareDesc(noteA.createdAt, noteB.createdAt))
            .map(note => (
              <CustomerNoteCard
                key={note.id}
                note={note}
              />
            ))
        }
      </>
    );
  }
};

export default CustomerNotes;
